import liff from "@line/liff";
import Axios from "@/config/backend-customer";
import store from '@/store/store'

export const checkLineUser = async (to, from, next) => {
    try {
        Axios.post("/getMicrositeInfo ", {
            prefix_path: to.params.prefix_path,
        }).then(res => {
            const responseData = res.data
            if (responseData.message == 'Success') {

                store.commit("KEEP_TEMPLATE", res.data.Info);

                if (responseData.Info.microsite_type == "Survey") {
                    LineLogin()
                } else {
                    next()
                }
            }
        }).catch(err => {
            console.log('err :>> ', err);
        })

        const LineLogin = async () => {
            await liff.init({ liffId: store.state.template.liffID }).catch((err) => {
                throw err;
            });

            if (!liff.isLoggedIn()) {
                liff.login({
                    redirectUri: window.location.href
                })
            }

            const profile = await liff.getProfile();
            if (profile) {
                store.commit("KEEP_LINE_INFO", profile);
                const payload = {
                    line_id: profile.userId,
                    microsite_id: store.state.template.microsite_id
                }
                const { data } = await Axios.post('survey/checkLineRegister', payload)
                if (data.detail == "unregister") {

                    next({
                        name: "register-customer",
                        params: {
                            prefix_path: store.state.template.prefix_path
                        }
                    })
                    return
                }
                if (data.detail == "registered") {
                    localStorage.setItem("token", data.token);
                    store.commit("SET_TOKEN", data.token);
                    store.commit("SET_USER", { role: "Customer" });
                    next({
                        name: "survey-customer",
                        params: {
                            prefix_path: store.state.template.prefix_path
                        }
                    })
                    return
                }
                if (data.detail == "formed") {
                    localStorage.setItem("token", data.token);
                    store.commit("SET_TOKEN", data.token);
                    store.commit("SET_USER", { role: "Customer" });
                    next({
                        name: "discount-customer"
                    })
                    return
                }
            } else {
                return
            }
        }
    } catch (err) {
        console.log(`liff.state init error ${err}`)
    }
}